import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "What does an educational software developer do?",
    answer: `<p>EdTech developers are leading the charge in transforming traditional education models with personalized learning paths. By leveraging data-driven insights and AI algorithms, they craft adaptable platforms that cater to each student's unique journey, strengths, and areas for improvement.</p>`,
  },
  {
    question: "What is an educational software company?",
    answer: `<p>Leading educational software development firms provide tailored software solutions for organizations in the education sector, encompassing services such as software conceptualization, creation, testing, deployment, and upkeep.</p>`,
  },
  {
    question: "What does educational software include?",
    answer: `<p>Educational software refers to computer programs designed for educational purposes. It covers a wide spectrum from language learning to classroom management and reference tools.</p>`,
  },
  {
    question: "How much does it cost to build educational software?",
    answer: `<p>Building educational software can range from $15,000 to $50,000. However, the overall cost is dependent on how complex your educational software is.</p>`,
  },
  {
    question:
      "What to look for in a custom educational software development company?",
    answer: `<p>When it comes to selecting a custom educational software development firm, make sure they are knowledgeable in educational technology, have a successful history on projects similar to yours, have a collaborative approach, focus on user-centered design, and are familiar with the latest educational methodologies.</p>`,
  },
  {
    question:
      "Does TekRevol offer maintenance and support for educational software development?",
    answer: `<p>Yes, TekRevol offers complete maintenance even after the deployment of the project. You can have our constant support at any stage to ensure the optimal performance of the educational software with a satisfying user experience.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg home">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
